export class NegativeReasonCode {
  numeratorId?: number;
  id?: number;
  name?: string;

  constructor(options: Partial<NegativeReasonCode>) {
    this.numeratorId = options.numeratorId;
    this.id = options.id;
    this.name = options.name;
  }
}
